export const NUXT_SITEMAP_URLS = [
  "/11th/computer/",
  "/11th/computer/paper-pattern/",
  "/11th/computer/pairing-scheme/",
  "/11th/computer/important-questions/",
  "/11th/computer/guess-paper/",
  "/11th/computer/notes/",
  "/11th/computer/notes-pdf/",
  "/11th/computer/notes-pdf/sdlc/",
  "/11th/computer/notes-pdf/python/",
  "/11th/computer/notes-pdf/algorithm/",
  "/11th/computer/notes-pdf/data-structures/",
  "/11th/computer/notes-pdf/data-analytics/",
  "/11th/computer/mcqs/",
  "/11th/computer/mcqs/top-100/",
  "/11th/computer/short-questions/",
  "/11th/computer/long-questions/",
  "/11th/computer/solved-exercise/",
  "/11th/computer/practice/",
  "/11th/computer/practice/mcqs/",
  "/11th/computer/practice/short-questions/",
  "/11th/computer/practice/long-questions/",
  "/11th/computer/mcqs/chapter-1-sdlc/",
  "/11th/computer/mcqs/chapter-2-python/",
  "/11th/computer/mcqs/chapter-3-algorithms/",
  "/11th/computer/mcqs/chapter-4-data-structures/",
  "/11th/computer/mcqs/chapter-5-data-analytics/",
  "/11th/computer/mcqs/chapter-6-emerging-technologies/",
  "/11th/computer/mcqs/chapter-7-legal-and-ethical-aspects/",
  "/11th/computer/mcqs/chapter-8-digital-literacy/",
  "/11th/computer/mcqs/chapter-9-entrepreneurship/",
  "/11th/computer/sdlc/",
  "/11th/computer/sdlc/mcqs/",
  "/11th/computer/sdlc/short-questions/",
  "/11th/computer/sdlc/long-questions/",
  "/11th/computer/sdlc/exercise/",
  "/11th/computer/python/",
  "/11th/computer/python/notes/",
  "/11th/computer/python/mcqs/",
  "/11th/computer/python/short-questions/",
  "/11th/computer/python/long-questions/",
  "/11th/computer/python/solved-exercise/",
  "/11th/computer/python/exercise/",
  "/11th/computer/python/variables/",
  "/11th/computer/python/data-types/",
  "/11th/computer/python/comments/",
  "/11th/computer/python/operators/",
  "/11th/computer/python/loops/",
  "/11th/computer/python/functions/",
  "/11th/computer/python/modules/",
  "/11th/computer/python/programs/",
  "/11th/computer/algorithm/",
  "/11th/computer/algorithm/mcqs/",
  "/11th/computer/algorithm/short-questions/",
  "/11th/computer/algorithm/long-questions/",
  "/11th/computer/algorithm/exercise/",
  "/11th/computer/data-structures/",
  "/11th/computer/data-structures/mcqs/",
  "/11th/computer/data-structures/short-questions/",
  "/11th/computer/data-structures/long-questions/",
  "/11th/computer/data-structures/exercise/",
  "/11th/computer/data-analytics/",
  "/11th/computer/data-analytics/mcqs/",
  "/11th/computer/data-analytics/short-questions/",
  "/11th/computer/data-analytics/long-questions/",
  "/11th/computer/data-analytics/exercise/",
  "/11th/computer/emerging-tech/",
  "/11th/computer/emerging-tech/mcqs/",
  "/11th/computer/emerging-tech/short-questions/",
  "/11th/computer/emerging-tech/long-questions/",
  "/11th/computer/emerging-tech/exercise/",
  "/11th/computer/legal-ethics/",
  "/11th/computer/legal-ethics/mcqs/",
  "/11th/computer/legal-ethics/short-questions/",
  "/11th/computer/legal-ethics/long-questions/",
  "/11th/computer/legal-ethics/exercise/",
  "/11th/computer/digital-literacy/",
  "/11th/computer/digital-literacy/mcqs/",
  "/11th/computer/digital-literacy/short-questions/",
  "/11th/computer/digital-literacy/long-questions/",
  "/11th/computer/digital-literacy/exercise/",
  "/11th/computer/entrepreneurship/",
  "/11th/computer/entrepreneurship/mcqs/",
  "/11th/computer/entrepreneurship/short-questions/",
  "/11th/computer/entrepreneurship/long-questions/",
  "/11th/computer/entrepreneurship/exercise/",
];
